var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$slots.default)?_c(_setup.tagEl,_vm._b({tag:"component"},'component',_vm.$attrs,false),[(_vm.$slots.default)?_vm._t("default"):_vm._e()],2):(_setup.text)?_c(_setup.tagEl,_vm._b({tag:"component",domProps:{"innerHTML":_vm._s(_setup.text)}},'component',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }